module.exports = __webpack_public_path__ + "img/202411_02.2e2a151b.jpg";